interface FloatingState {
  placement: string
  elements: {
    reference: Element | { getBoundingClientRect: () => DOMRect }
    floating: HTMLElement
  }
}

interface FloatingMiddleware {
  name: string
  fn: (state: FloatingState) => { reset?: { rects: true } }
}

/**
 * Floating UI middleware capping the floating element to the viewport height left on its
 * placement side, so a tall panel scrolls inside instead of overflowing the screen.
 * Dependency-free equivalent of floating-ui's `size` middleware, for `<Float :middleware>`.
 */
export const floatingMaxHeight = (
  offset = 0,
  padding = 8
): FloatingMiddleware => ({
  name: 'floatingMaxHeight',
  fn({ placement, elements }) {
    const referenceRect = elements.reference.getBoundingClientRect()
    const availableHeight = placement.startsWith('top')
      ? referenceRect.top - offset - padding
      : window.innerHeight - referenceRect.bottom - offset - padding
    const maxHeight = `${Math.max(Math.floor(availableHeight), 0)}px`

    if (elements.floating.style.maxHeight === maxHeight) {
      return {}
    }
    elements.floating.style.maxHeight = maxHeight

    return { reset: { rects: true } }
  }
})
